import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

export const useSocket = () => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Connect to socket server with explicit URL and options
    console.log('Initializing socket connection...');
    
    // Determine the socket URL based on the environment
    let socketUrl;
    if (window.location.hostname === 'localhost' && window.location.port === '3000') {
      // Development mode - React dev server
      socketUrl = 'http://localhost:3000';
    } else {
      // Production mode or Docker - connect to same origin
      socketUrl = window.location.origin;
    }
    
    console.log('Connecting to socket at:', socketUrl);
    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      timeout: 5000,
    });
    
    newSocket.on('connect', () => {
      console.log('Socket.io connected with ID:', newSocket.id);
      setSocket(newSocket); // This will trigger re-render in App component
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket.io connection error:', error);
    });

    newSocket.on('disconnect', (reason) => {
      console.log('Socket.io disconnected:', reason);
      setSocket(null);
    });
    
    return () => {
      if (newSocket) {
        console.log('Cleaning up socket connection');
        newSocket.disconnect();
      }
    };
  }, []);

  return socket;
};